import React from "react";
import {
  Box,
  Col,
  Dialog,
  FabButton,
  Flex,
  Gap,
  Icon,
  InputField,
  Row,
  SelectField,
  Typography,
} from "../../../../ppui";
import { OrganizationBx, OrganizationEmDetails } from "../../../style";
import {
  TbCalendarTime,
  TbDroplet,
  TbHeartHandshake,
  TbMapPin,
  TbPencil,
  TbPhone,
  TbUser,
} from "react-icons/tb";

const AboutMe = () => {
  const [AboutMeEdit, setAboutMe] = React.useState(false);
  const AboutMeModalOpen = () => setAboutMe(true);
  const AboutMeModalClose = () => setAboutMe(false);
  return (
    <>
      <Flex justifyContent="space-between" gap={"10"}>
        <Typography variant="h5" mb={"0"}>
          About Me
        </Typography>
        <FabButton
          size="sm"
          icon={<TbPencil />}
          onClick={AboutMeModalOpen}
          variant="filled"
          shape="box"
        />
      </Flex>
      <Gap height={30} />
      <OrganizationEmDetails>
        <OrganizationBx>
          <Icon size={"lg"}>
            <TbCalendarTime />
          </Icon>
          <Box>
            <Typography variant="body2" mb={"0"}>
              Date of Birth
            </Typography>
            <Typography variant="body1" mb={"0"} color="primary">
              08-01-1998
            </Typography>
          </Box>
        </OrganizationBx>

        <OrganizationBx>
          <Icon size={"lg"}>
            <TbPhone />
          </Icon>
          <Box>
            <Typography variant="body2" mb={"0"}>
              Alternative Contact Number
            </Typography>
            <Typography variant="body1" mb={"0"} color="primary">
              33-1234 5678
            </Typography>
          </Box>
        </OrganizationBx>

        <OrganizationBx>
          <Icon size={"lg"}>
            <TbMapPin />
          </Icon>
          <Box>
            <Typography variant="body2" mb={"0"}>
              Permanent Address
            </Typography>
            <Typography variant="body1" mb={"0"} color="primary">
              1234 Elm Street, Apt 5B. Salt Lake, Kolkata.
            </Typography>
          </Box>
        </OrganizationBx>

        <OrganizationBx>
          <Icon size={"lg"}>
            <TbMapPin />
          </Icon>
          <Box>
            <Typography variant="body2" mb={"0"}>
              Present Address
            </Typography>
            <Typography variant="body1" mb={"0"} color="primary">
              1234 Elm Street, Apt 5B. Salt Lake, Kolkata.
            </Typography>
          </Box>
        </OrganizationBx>

        <OrganizationBx>
          <Icon size={"lg"}>
            <TbDroplet />
          </Icon>
          <Box>
            <Typography variant="body2" mb={"0"}>
              Blood Group
            </Typography>
            <Typography variant="body1" mb={"0"} color="primary">
              A+
            </Typography>
          </Box>
        </OrganizationBx>

        <OrganizationBx>
          <Icon size={"lg"}>
            <TbUser />
          </Icon>
          <Box>
            <Typography variant="body2" mb={"0"}>
              Gender
            </Typography>
            <Typography variant="body1" mb={"0"} color="primary">
              Male
            </Typography>
          </Box>
        </OrganizationBx>

        <OrganizationBx>
          <Icon size={"lg"}>
            <TbHeartHandshake />
          </Icon>
          <Box>
            <Typography variant="body2" mb={"0"}>
              Marital Status
            </Typography>
            <Typography variant="body1" mb={"0"} color="primary">
              Married
            </Typography>
          </Box>
        </OrganizationBx>
      </OrganizationEmDetails>

      <Dialog
        title="About Me"
        closeButton={true}
        fullWidth
        maxWidth="sm"
        open={AboutMeEdit}
        onClose={AboutMeModalClose}
        separator
      >
        <Row rowGap={20}>
          <Col sm={12} md={6}>
            <InputField
              required
              fullWidth
              label="Date of Birth"
              type="date"
              placeholder="Type Here"
              valueSinc={true}
            />
          </Col>

          <Col sm={12} md={6}>
            <InputField
              required
              fullWidth
              label="Permanent Address"
              type="text"
              placeholder="Type Here"
              valueSinc={true}
            />
          </Col>

          <Col sm={12} md={6}>
            <InputField
              required
              fullWidth
              label="Present Address"
              type="text"
              placeholder="Type Here"
              valueSinc={true}
            />
          </Col>

          <Col sm={12} md={6}>
            <SelectField
              fullWidth
              required
              label="Blood Group"
              options={[
                { id: "option1", name: "A+" },
                { id: "option2", name: "A-" },
                { id: "option3", name: "B+" },
                { id: "option4", name: "B-" },
                { id: "option5", name: "AB+" },
                { id: "option6", name: "AB-" },
                { id: "option7", name: "O+" },
                { id: "option8", name: "O-" },
              ]}
              defaultValue="fixed"
              placeholder="Select Here..."
            />
          </Col>
          <Col sm={12} md={6}>
            <SelectField
              fullWidth
              required
              label="Gender"
              options={[
                { id: "option1", name: "Male" },
                { id: "option2", name: "Female" },
                { id: "option3", name: "Transgender" },
              ]}
              defaultValue="fixed"
              placeholder="Select Here..."
            />
          </Col>

          <Col sm={12} md={6}>
            <SelectField
              fullWidth
              required
              label="Marital Status"
              options={[
                { id: "option1", name: "Married" },
                { id: "option2", name: "Single" },
                { id: "option3", name: "Divorced" },
              ]}
              defaultValue="fixed"
              placeholder="Select Here..."
            />
          </Col>
        </Row>
      </Dialog>
    </>
  );
};

export default AboutMe;
